import { Button, Typography, Paper, Grid, Tooltip } from "@material-ui/core";
import * as React from "react";
import { PortalAppBar } from "src/components/app-bar";
import { observable, computed } from "mobx";
import { authStore, checkAuthStore } from "../auth";
import {
  Redirect,
  Route,
  Switch,
  withRouter,
  BrowserRouter as Router,
  RouteComponentProps,
} from "react-router-dom";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { UserPanel } from ".";
import trianglify from "src/resources/trianglify.png";
import { AppPanel } from "src/modules/apps";
import { UsersAdmin } from "src/modules/admin/modules/UsersAdmin";
import { UserAccount } from "src/modules/admin/modules/UsersAdmin/components";
import { UserAccountPassword } from "src/modules/admin/modules/UsersAdmin/components";
import { CompaniesAdmin } from "src/modules/admin/modules/CompaniesAdmin";
import { observer } from "mobx-react";
import * as _ from "lodash";
import SmallFooter from "src/components/footer/SmallFooter";
import { CompaniesAdminDetails } from '../admin/modules/CompaniesAdmin/components';
import { Permissions } from '../admin/modules/Permissions';
import { UsersAdminDetails } from '../admin/modules/UsersAdmin/components';
import { PortalRoute } from '.';
import { PasswordVerify } from '.';
import ChangeUserPassword from '../admin/modules/UsersAdmin/components/ChangeUserPassword';
import { Dashboard } from '../dashboard';
import { Settings } from '../admin/modules/Settings';
import { config } from 'src/config';
import Support from '../support/Support';

const styles = createStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    height: "100vh",
    flexWrap: "nowrap",
  },
  body: {
    // width: "calc(100% - 3rem)",
    // height: "calc(100% - 3rem)",
    width: "100%",
    display: "flex",
    flexGrow: 1,
    padding: "1.5rem",
    margin: 0,
    backgroundImage: `url(${trianglify})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    flexDirection: "row-reverse",
  },
  paper: {
    flex: 1,
    border: "solid .5px #194b87",
    // display: "flex",
    overflow: "auto",
    marginBottom: '30px'
  },
  pageContainer: {
    height: "100%",
    padding: "1.5rem",
    overflowX: 'hidden'
  },
  mainContentContainer: {
    display: "flex",
    flex: "auto",
    maxHeight: "100%",
  },
  sideBarContainer: {
    // width: "18rem",
  },
});

@observer
class StyledPortal extends React.Component<
WithStyles<typeof styles> & RouteComponentProps
> {
  @observable
  public SessionKey: string | null;

  public state = {
    chatOpen: false,
    chatTooltipOpen: false
  }

  constructor(props: any) {
    super(props);
    this.SessionKey = localStorage.getItem("token");
  }

  public log = () => {
    console.log(this.props);
  };


  public receiveMessage = (event: any) => {
    if (event.data.fn === 'restoreWindow') {
      this.setState({ chatOpen: true, chatTooltipOpen: false })
    }
    else if (event.data.fn === 'minimizeWindow') {
      this.setState({ chatOpen: false })
    }
  }

  public handleChatTooltipOpen = () => {
    // const sendAction = () => {
    //   console.log('actions')
    //   const isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
    //     input !== null && input.tagName === 'IFRAME';

    //   const iframeEl = document.getElementById("portal-frame");

    //   if (isIFrame(iframeEl) && iframeEl.contentWindow) {
    //     console.log('iframe')
    //     iframeEl.contentWindow.postMessage('action', '*')
    //   }
    // }

    if (this.state.chatOpen) {
      return

    }
    // sendAction()
    this.setState({ chatTooltipOpen: true })
  }

  public handleChatTooltipClosed = () => {
    this.setState({ chatTooltipOpen: false })
  }


  public render() {
    const { classes, location } = this.props;



    window.addEventListener("message", this.receiveMessage, true);

    const chatdiv = (prop: unknown) => {
      if (prop) {
        return (
          <div style={{ width: '100%', height: '100%' }}>
            <iframe
              id="portal-frame"
              className="portal-frame"
              frameBorder="0"
              src={config.BASE_CHAT_URL + '/' + authStore.currentUser.SessionKey}
              width={'100%'}
              height={'100%'}
            />
          </div>
        )
      }
      return null
    }

    let isChrome = !!(window as any).chrome && (!!(window as any).chrome.webstore || !!(window as any).chrome.runtime);

    let mobile = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      mobile = true;
      isChrome = true;
    }


    if (!isChrome && config.ONLY_ALLOW_CHROME) {
      return <div style={{
        margin: 'auto',
        width: '50%',
        textAlign: 'center',
        marginTop: '100px',
        border: '2px solid darkblue',
        padding: '10px'
      }} >
        <div>Browser incompatible, please use Chrome</div>
        <div><a href="https://www.google.com/chrome/">Download Chrome Here</a></div></div>
    }

    return (
      <Grid container={true} className={classes.root}>
        <PortalAppBar />
        <Grid container={true} spacing={40} style={{ height: '100%' }}>
          <Grid item={true} xs={2}>
            <Paper className={classes.paper}>
              <UserPanel />
            </Paper>
          </Grid>
          <Grid item={true} xs={9} className={classes.mainContentContainer}>
            <Paper className={classes.paper}>
              <Switch>
                <PortalRoute path={"/admin/users/edit/password/:id(\\d+)"} component={ChangeUserPassword} permission={{ PermissionCategory: 'user', PermissionType: 'update' }} />
                <PortalRoute path={"/admin/users/:view_type/:id(\\d+)"} component={UsersAdminDetails} permission={{ PermissionCategory: 'user', PermissionType: 'read' }} />
                <PortalRoute path={"/admin/users/:view_type"} component={UsersAdminDetails} permission={{ PermissionCategory: 'user', PermissionType: 'read' }} />
                <PortalRoute path="/admin/users" component={UsersAdmin} permission={{ PermissionCategory: 'user', PermissionType: 'read' }} />

                <PortalRoute path={"/admin/companies/:view_type/:id(\\d+)"} component={CompaniesAdminDetails} permission={{ PermissionCategory: 'company', PermissionType: 'read' }} />
                <PortalRoute path={"/admin/companies/:view_type"} component={CompaniesAdminDetails} permission={{ PermissionCategory: 'company', PermissionType: 'read' }} />
                <PortalRoute path="/admin/companies" component={CompaniesAdmin} permission={{ PermissionCategory: 'company', PermissionType: 'read' }} />

                <PortalRoute path="/admin/permissions" component={Permissions} permission={{ PermissionCategory: 'permission', PermissionType: 'read' }} />
                <PortalRoute path="/admin/settings" component={Settings} permission={{ PermissionCategory: 'settings', PermissionType: 'read' }} />

                <PortalRoute path="/support" component={Support} permission={{ PermissionCategory: 'support', PermissionType: 'read' }} />

                <PortalRoute path="/dashboard" component={Dashboard} permission={{ PermissionCategory: 'dashboard', PermissionType: 'read' }} />
                <PortalRoute path={"/account/password/:id(\\d+)"} component={UserAccountPassword} permission={{ PermissionCategory: 'dashboard', PermissionType: 'read' }} />
                <PortalRoute path="/account" component={UserAccount} permission={{ PermissionCategory: 'dashboard', PermissionType: 'read' }} />
                <PortalRoute path="/password-verify" component={PasswordVerify} />
                <PortalRoute path="/" component={Dashboard} permission={{ PermissionCategory: 'dashboard', PermissionType: 'read' }} />
              </Switch>
            </Paper>
          </Grid>
        </Grid>
        {/* tslint:disable-next-line: jsx-no-lambda */}
        <Tooltip
          title={'Live Support'}
          placement={'left'}
          open={this.state.chatTooltipOpen}
          onOpen={this.handleChatTooltipOpen}
          onClose={this.handleChatTooltipClosed}
        >
          <div id="chat-container" style={{ position: 'absolute', right: 0, bottom: 0, height: this.state.chatOpen ? '500px' : '100px', width: this.state.chatOpen ? '500px' : '100px', zIndex: 1 }} >
            {chatdiv(authStore.loaded)}
          </div>
        </Tooltip>

      </Grid>
    );
  }
}

export const Portal = withStyles(styles, { withTheme: true })(StyledPortal);


// WEBPACK FOOTER //
// ./src/modules/portal/Portal.tsx